import * as yup from "yup";
import { emailValidation, usernameValidator } from "./commonValidators";

export const addUserValidator = yup.object({
  username: usernameValidator("Username"),
  groupname: yup.string().required("Role name is required"),
  first_name: usernameValidator("First name"),
  last_name: usernameValidator("Last name"),
  email: emailValidation,
  password: yup.string().required("Password is required"),
  confirm_password: yup
    .string()
    .test(
      "confirmPassword",
      "Passwords must match",
      (value, context) => value === context.parent.password,
    ),
});
